module.exports = __webpack_public_path__ + "static/media/005-Wechseln_ID_29.8c8ffd60.mp3";